// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const View = {
  Pmtiles: "pmtiles",
  InversePmtiles: "inverse-pmtiles",
  Tabular: "tabular",
} as const;
export type View = (typeof View)[keyof typeof View];

export function instanceOfView(value: any): boolean {
  for (const key in View) {
    if (Object.prototype.hasOwnProperty.call(View, key)) {
      if (View[key as keyof typeof View] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ViewFromJSON(json: any): View {
  return ViewFromJSONTyped(json, false);
}

export function ViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): View {
  return json as View;
}

export function ViewToJSON(value?: View | null): any {
  return value as any;
}

export function ViewToJSONTyped(value: any, ignoreDiscriminator: boolean): View {
  return value as View;
}
